import React from "react";
import { BrowserRouter, Routes, Route, Navigate, Outlet } from "react-router-dom";
import { AuthProvider, useAuth } from "@/lib/auth";
import Login from "@/pages/Login";
import Layout from "@/components/Layout";
import Dashboard from "@/pages/Dashboard";
import GoodsReceipt from "@/pages/GoodsReceipt";
import Issue from "@/pages/Issue";
import StockBrowser from "@/pages/StockBrowser";
import ContainerOps from "@/pages/ContainerOps";
import Activity from "@/pages/Activity";
import Approvals from "@/pages/Approvals";
import Reports from "@/pages/Reports";
import AdminUsers from "@/pages/AdminUsers";
import AdminLocations from "@/pages/AdminLocations";
import AdminItems from "@/pages/AdminItems";
import AdminSuppliers from "@/pages/AdminSuppliers";
import Settings from "@/pages/Settings";
import ReceiverHome from "@/pages/ReceiverHome";
import Formulations from "@/pages/Formulations";
import ProductionOrders from "@/pages/ProductionOrders";
import Traceability from "@/pages/Traceability";
import Transfers from "@/pages/Transfers";
import ImportStock from "@/pages/ImportStock";
import Arrange from "@/pages/Arrange";
import RoomMap from "@/pages/RoomMap";

function Protected({ children }) {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen grid place-items-center text-muted-foreground">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function AppRoutes() {
  const { user } = useAuth();
  const isReceiver = user && user.role === "receiver";
  return (
    <Routes>
      <Route path="/login" element={<Login />} />
      <Route element={<Protected><Layout /></Protected>}>
        {isReceiver ? (
          <>
            <Route index element={<ReceiverHome />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        ) : (
          <>
            <Route index element={<Dashboard />} />
            <Route path="receipt" element={<GoodsReceipt />} />
            <Route path="issue" element={<Issue />} />
            <Route path="stock" element={<StockBrowser />} />
            <Route path="containers" element={<ContainerOps />} />
            <Route path="transfers" element={<Transfers />} />
            <Route path="arrange" element={<Arrange />} />
            <Route path="map" element={<RoomMap />} />
            <Route path="activity" element={<Activity />} />
            <Route path="approvals" element={<Approvals />} />
            <Route path="reports" element={<Reports />} />
            <Route path="production" element={<ProductionOrders />} />
            <Route path="trace" element={<Traceability />} />
            <Route path="formulations" element={<Formulations />} />
            <Route path="admin/users" element={<AdminUsers />} />
            <Route path="admin/locations" element={<AdminLocations />} />
            <Route path="admin/items" element={<AdminItems />} />
            <Route path="admin/suppliers" element={<AdminSuppliers />} />
            <Route path="admin/import" element={<ImportStock />} />
            <Route path="settings" element={<Settings />} />
            <Route path="*" element={<Navigate to="/" replace />} />
          </>
        )}
      </Route>
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <AppRoutes />
      </AuthProvider>
    </BrowserRouter>
  );
}
